/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Irrigation_Rename_ActionInputs */

const vi_irrigation_rename_action = /** @type {(inputs: Irrigation_Rename_ActionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đổi tên trạm ${i?.name}`)
};

/**

* @param {Irrigation_Rename_ActionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_rename_action = /** @type {((inputs: Irrigation_Rename_ActionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Rename_ActionInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_rename_action(inputs)
});